import { useMemo } from 'react';
import { BetWithMarketOutcomeEvent } from '../../../../@types';
import { areMarketsCombinable } from '../../../../helpers';

export const useGroupedReofferedBets = (bets: BetWithMarketOutcomeEvent[]) => {
  const groupedBets = useMemo(() => {
    const betsByEvent = bets.reduce(
      (acc: Record<string, BetWithMarketOutcomeEvent[]>, bet) => {
        const eventId = bet.event.id;
        if (!acc[eventId]) {
          acc[eventId] = [];
        }
        acc[eventId].push(bet);
        return acc;
      },
      {} as Record<string, BetWithMarketOutcomeEvent[]>
    );

    const result: BetWithMarketOutcomeEvent[][] = [];

    Object.values(betsByEvent).forEach((eventBets) => {
      if (eventBets.length === 1) {
        result.push(eventBets);
        return;
      }

      const nonCombinableBets: BetWithMarketOutcomeEvent[] = [];

      eventBets.forEach((currentBet) => {
        const isCombinable = eventBets.some(
          (otherBet) =>
            otherBet.outcomeId !== currentBet.outcomeId &&
            areMarketsCombinable(currentBet.market.marketType, otherBet.market.marketType)
        );

        if (isCombinable) {
          result.push([currentBet]);
        } else {
          nonCombinableBets.push(currentBet);
        }
      });

      if (nonCombinableBets.length > 0) {
        result.push(nonCombinableBets);
      }
    });

    return result;
  }, [bets]);

  return groupedBets;
};
